import { NavLink, useNavigate } from "react-router-dom";
import { FaTachometerAlt, FaSearch, FaFileAlt, FaSignOutAlt, FaBars, FaTimes, FaCog, FaUsers, FaServer, FaQuestionCircle } from "react-icons/fa";
import { useSidebar } from "../../App";
import "../../styles/sidebar.css";
import { getApiUrl, getCsrfToken, clearCsrfToken, clearUserId } from "../../utils/apiHelper";

export default function AisprawlSidebar() {
  const navigate = useNavigate();
  const { sidebarCollapsed, setSidebarCollapsed } = useSidebar();

  const handleLogout = async () => {
    try {
      const csrfToken = await getCsrfToken();
      await fetch(getApiUrl('/api/internal/auth/logout/'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': csrfToken,
        },
        credentials: 'include',
      });
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      clearCsrfToken();
      clearUserId();
      localStorage.removeItem('user');
      navigate('/login');
    }
  };

  const menuItems = [
    { path: "/aisprawl/dashboard", name: "Dashboard", icon: <FaTachometerAlt /> },
    { path: "/aisprawl/scan", name: "Scan", icon: <FaSearch /> },
    { path: "/aisprawl/config", name: "Config", icon: <FaCog /> },
    { path: "/aisprawl/reports", name: "Reports", icon: <FaFileAlt /> },
    { path: "/aisprawl/users", name: "Users", icon: <FaUsers /> },
    { path: "/aisprawl/system", name: "System", icon: <FaServer /> },
    { path: "/aisprawl/help", name: "Help", icon: <FaQuestionCircle /> },
  ];

  return (
    <div className={`sidebar ${sidebarCollapsed ? 'collapsed' : ''}`}>
      <button
        className="sidebar-toggle"
        onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
        title={sidebarCollapsed ? "Expand sidebar" : "Collapse sidebar"}
      >
        {sidebarCollapsed ? <FaBars /> : <FaTimes />}
      </button>

      <nav className="menu">
        {menuItems.map((item, index) => (
          <NavLink
            to={item.path}
            key={index}
            className="menu-item"
            activeclassname="active"
            title={sidebarCollapsed ? item.name : ""}
          >
            <span className="icon">{item.icon}</span>
            {!sidebarCollapsed && <span className="text">{item.name}</span>}
          </NavLink>
        ))}

        <button
          onClick={handleLogout}
          className="menu-item logout-button"
          title={sidebarCollapsed ? "Logout" : ""}
        >
          <span className="icon"><FaSignOutAlt /></span>
          {!sidebarCollapsed && <span className="text">Logout</span>}
        </button>
      </nav>
    </div>
  );
}
